var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w3-modal w3-show"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('h3',{staticClass:"w3-center w3-text-white"},[_vm._v(" ... đang tải ... ")])])
}]

export { render, staticRenderFns }